<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>中文官网</el-breadcrumb-item>
        <el-breadcrumb-item>职位管理</el-breadcrumb-item>
        <el-breadcrumb-item>工作地点</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="handleAdd()">添加</el-button></span>
    </div>
    <div>
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="工作地点">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="320">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                v-show="scope.row.id !== 1000"
                @click="edit(scope.$index)">编辑
              </el-button>
              <el-popconfirm
                v-show="scope.row.id !== 1000"
                confirmButtonText='确认'
                cancelButtonText='取消'
                icon="el-icon-info"
                iconColor="red"
                title="删除不可恢复，确定删除吗？"
                @onConfirm="del(scope.row.id)"
                :loading="loading"
              >
                <el-button type="primary" size="small" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <el-dialog title="编辑" :visible.sync="dialogVisible" :close-on-click-modal="false"  width="600px" class="padding_10">
      <el-form :model="form" label-width="120px" :rules="storeRoleRules" ref="addForm">
        <el-form-item label="工作地点" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="submit()">确 定</el-button>
        <el-button @click="dialogVisible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  updateCity,
  getCityList,
  delCity,
  createCity
} from '../../api/city'

export default {
  name: 'index',
  data () {
    return {
      made: 'create',
      loading: false,
      dialogVisible: false,
      tableData: [],
      storeRoleRules: {
        name: [
          {required: true, message: '请输入工作地点', trigger: 'blur'}
        ]
      },
      form: {
        id: '',
        name: ''
      }
    }
  },
  methods: {
    handleAdd () {
      this.made = 'create'
      this.form.id = ''
      this.form.name = ''
      this.dialogVisible = true
    },
    add () {
      createCity(this.form).then(res => {
        this.$notify({
          message: '创建成功',
          type: 'success',
          offset: 100,
          showClose: false
        })
        this.loadCityList()
        this.dialogVisible = false
      })
    },
    update () {
      updateCity(this.form).then(res => {
        this.$notify({
          message: '更新成功',
          type: 'success',
          offset: 100,
          showClose: false
        })
        this.loadCityList()
        this.dialogVisible = false
      })
    },
    submit () {
      this.loading = true
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          if (this.made === 'create') {
            this.add()
          } else {
            this.update()
          }
        } else {
          return false
        }
      })
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    edit (index) {
      this.made = 'edit'
      let item = this.tableData[index]
      this.form.name = item.name
      this.form.id = item.id
      this.dialogVisible = true
    },
    del (id) {
      this.loading = true
      delCity(id).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.loadCityList()
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
      this.loading = false
    },
    loadCityList () {
      getCityList().then(response => {
        this.tableData = response.data.table_list
      })
    }
  },
  mounted () {
    this.loadCityList()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/city/index.vue